module.exports = __webpack_public_path__ + "static/media/a21_wba.c5a6b7c6.png";